export default __webpack_public_path__ + "static/media/Fantasy_06.d064ce57.png";